
//** This file changes the collection filters to be sticky when scrolling up


(() => {
  let bar = null;
  let spacer = null;
  let initialTop = 0;
  let lastScroll = window.scrollY;

  // Toggling the bar to position:fixed removes it from the document flow, so
  // without this the product list snaps up/down by the bar's height every time
  // it shows or hides. The spacer holds that height open in flow instead, so
  // the bar can leave/rejoin flow without anything below it moving.
  const ensureSpacer = () => {
    if (spacer && spacer.isConnected) return spacer;
    const sibling = bar.previousElementSibling;
    spacer = sibling && sibling.classList.contains('product-facet__meta-bar-spacer') ? sibling : null;
    return spacer;
  };

  const refreshBar = () => {
    bar = document.querySelector('.product-facet__meta-bar');
    if (!bar) return;
    // Recompute initialTop only when the bar is in normal flow (not currently sticky).
    if (!bar.classList.contains('is-sticky')) {
      initialTop = bar.offsetTop;
    }
    ensureSpacer();
  };

  const setSticky = (sticky) => {
    if (sticky === bar.classList.contains('is-sticky')) return;

    if (sticky) {
      // Measure while still in normal flow: the bar's own margins are part of
      // the space it holds open, not just its box height.
      const barStyle = getComputedStyle(bar);
      const height = bar.offsetHeight;
      const marginTop = barStyle.marginTop;
      const marginBottom = barStyle.marginBottom;
      bar.classList.add('is-sticky');
      // Only reserve space if this viewport's CSS actually detaches the bar
      // from flow (the sticky behavior is mobile-only) - checking the computed
      // position rather than duplicating the breakpoint here.
      if (getComputedStyle(bar).position === 'fixed' && ensureSpacer()) {
        spacer.style.height = height + 'px';
        spacer.style.marginTop = marginTop;
        spacer.style.marginBottom = marginBottom;
      }
    } else {
      bar.classList.remove('is-sticky');
      if (spacer) {
        spacer.style.height = '0px';
        spacer.style.marginTop = '0px';
        spacer.style.marginBottom = '0px';
      }
    }
  };

  const onScroll = () => {
    if (!bar || !bar.isConnected) {
      refreshBar();
      if (!bar) return;
    }

    const currentScroll = window.scrollY;

    if (currentScroll < lastScroll && currentScroll > initialTop) {
      setSticky(true);
    } else {
      setSticky(false);
    }

    lastScroll = currentScroll;
  };

  const init = () => {
    refreshBar();
    window.addEventListener('scroll', onScroll, { passive: true });
    // Re-bind whenever the product-facet section re-renders (filter/sort/pagination).
    document.addEventListener('pagination:content-updated', refreshBar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
